// extracted by mini-css-extract-plugin
export default {"forwardName":"Forward_forwardName_rTirt"};